"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HYPERLINK_ID_PREFIX = exports.URL_REGEX = void 0;
var angular_1 = __importDefault(require("angular"));
var quill_1 = __importDefault(require("quill"));
require("./hyperlinks-modal.less");
// From monolith QualtricsRegex.php
exports.URL_REGEX = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
exports.HYPERLINK_ID_PREFIX = 'hyperlink-';
var HyperlinkModalController = /** @class */ (function () {
    function HyperlinkModalController($scope, 
    // @ts-ignore
    eventService) {
        this.$scope = $scope;
        this.eventService = eventService;
        this._editor = $scope.editor;
        this._widgetId = $scope.widgetId;
        this.$ctrl = this;
        $scope.$ctrl = this.$ctrl;
    }
    HyperlinkModalController.prototype.$onInit = function () {
        this.displayText = '';
        this.linkUrl = '';
    };
    HyperlinkModalController.prototype.isValidUrl = function () {
        return exports.URL_REGEX.test(this.linkUrl);
    };
    /**
     * Save the hyperlink information and insert at the cursor
     * location in the quill editor. Only enabled if url is validated.
     */
    HyperlinkModalController.prototype.save = function () {
        // Find position to enter the element
        this._editor.focus();
        var range = this._editor.getSelection(true);
        var existingFormat = this._getExistingFormat(range.index) || {};
        this._insertHyperlinkHtml(range, existingFormat);
        // Trigger widget save
        this.eventService.stream(this._widgetId).trigger('hyperlink-save-state');
    };
    /**
     * Get the formatting of the text directly before the insert location.
     */
    HyperlinkModalController.prototype._getExistingFormat = function (locationIndex) {
        if (locationIndex === void 0) { locationIndex = 1; }
        // Default to 1 if locationIndex is 0 or undefined, to maintain index >= 0
        var index = (locationIndex || 1) - 1;
        var length = 1;
        return this._editor.getFormat(index, length);
    };
    /**
     * Insert HTML with the hyperlink into the quill editor.
     */
    HyperlinkModalController.prototype._insertHyperlinkHtml = function (range, existingFormat) {
        this._editor.updateContents(this._getQuillDelta()
            .retain(range.index)
            .insert({
            hyperlink: {
                hlAttrs: {
                    innerText: this.displayText,
                    url: this.linkUrl,
                    id: this._generateId()
                }
            }
        }, existingFormat));
    };
    /**
     * Create a new quill delta object.
     */
    HyperlinkModalController.prototype._getQuillDelta = function () {
        var delta = quill_1.default.import('delta');
        return new delta();
    };
    /**
     * Generate unique id for hyperlink element, with the hyperlink prefix
     * and 8 digit alphanumeric string.
     */
    HyperlinkModalController.prototype._generateId = function () {
        return exports.HYPERLINK_ID_PREFIX + Math.random().toString(36).substr(2, 8);
    };
    HyperlinkModalController.$inject = [
        '$scope',
        'prEventService'
    ];
    return HyperlinkModalController;
}());
exports.default = HyperlinkModalController;
(function (angularModule) {
    angularModule.controller('prHyperlinksModalController', HyperlinkModalController);
})(angular_1.default.module('qualtrics.pr'));
